import React, {Fragment, useState} from 'react';

function BulkLocationEditorGeneralLocationTypeStatus ({combinedLocationServicesMap, locationPatch, mergeIntoLocationPatch}) {

  const [auditOnly, setAuditOnly] = useState(locationPatch.locationType === "audit" ? true : (locationPatch.locationType === "customer" ? false : undefined));
  const [serviceAreaBusiness, setServiceAreaBusiness] = useState(locationPatch.businessAddress.isServiceAreaLocation === null ? undefined : locationPatch.businessAddress.isServiceAreaLocation);
  const [hideAddress, setHideAddress] = useState(locationPatch.listingManagementSpecs.hideAddress === null ? undefined : locationPatch.listingManagementSpecs.hideAddress);
  const [permanentlyClosed, setPermanentlyClosed] = useState(locationPatch.listingManagementSpecs.permanentlyClosed === null ? undefined : locationPatch.listingManagementSpecs.permanentlyClosed);

  const toggleAuditOnly = (auditOnly) => (event) => {
    const newAuditOnly = (event.target.checked) ? auditOnly : undefined;
    setAuditOnly(newAuditOnly);

    const merged = (newAuditOnly === undefined) ? {locationType: null} : (auditOnly ? {locationType: "audit"} : {locationType: "customer"});

    mergeIntoLocationPatch(merged);
  };

  const toggleServiceAreaBusiness = (serviceAreaBusiness) => (event) => {
    const newServiceAreaBusiness = (event.target.checked) ? serviceAreaBusiness : undefined;
    setServiceAreaBusiness(newServiceAreaBusiness);

    const merged = (newServiceAreaBusiness === undefined) ? {businessAddress: {isServiceAreaLocation: null}} : {businessAddress: {isServiceAreaLocation: newServiceAreaBusiness}};

    mergeIntoLocationPatch(merged);
  };

  const toggleHideAddress = (hideAddress) => (event) => {
    const newHideAddress = (event.target.checked) ? hideAddress : undefined;
    setHideAddress(newHideAddress);

    const merged = (newHideAddress === undefined) ? {listingManagementSpecs: {hideAddress: null}} : {listingManagementSpecs: {hideAddress: newHideAddress}};

    mergeIntoLocationPatch(merged);
  };

  const togglePermanentlyClosed = (permanentlyClosed) => (event) => {
    const newPermanentlyClosed = (event.target.checked) ? permanentlyClosed : undefined;
    setPermanentlyClosed(newPermanentlyClosed);

    const merged = (newPermanentlyClosed === undefined) ? {listingManagementSpecs: {permanentlyClosed: null}} : {listingManagementSpecs: {permanentlyClosed: newPermanentlyClosed}};

    mergeIntoLocationPatch(merged);
  };

  return <div className="card-spacer-top card-spacer-bottom">
    <h5>Location Type/Status</h5>
    <div className="content-spacer-top">
      <table style={{"width": "100%"}}>
        <tbody style={{"width": "100%"}}>
          <tr>
            <td style={{"width": "180px"}}>{/* Set width on first column so everything lines up nicely */}Audit Only</td>
            <td>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"auditonly-yes"} className="custom-control-input" checked={auditOnly === true}  onChange={toggleAuditOnly(true)} />
                <label className="custom-control-label" htmlFor={"auditonly-yes"}>Yes</label>
              </div>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"auditonly-no"} className="custom-control-input" checked={auditOnly === false}  onChange={toggleAuditOnly(false)} />
                <label className="custom-control-label" htmlFor={"auditonly-no"}>No</label>
              </div>
            </td>
          </tr>
          <tr>
            <td>Service Area Business</td>
            <td>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"serviceareabusiness-yes"} className="custom-control-input" checked={serviceAreaBusiness === true}  onChange={toggleServiceAreaBusiness(true)} />
                <label className="custom-control-label" htmlFor={"serviceareabusiness-yes"}>Yes</label>
              </div>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"serviceareabusiness-no"} className="custom-control-input" checked={serviceAreaBusiness === false}  onChange={toggleServiceAreaBusiness(false)} />
                <label className="custom-control-label" htmlFor={"serviceareabusiness-no"}>No</label>
              </div>
            </td>
          </tr>

          {!!combinedLocationServicesMap.listingManagement && <tr>
            <td>Hide Address</td>
            <td>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"hideAddress-yes"} className="custom-control-input" checked={hideAddress === true}  onChange={toggleHideAddress(true)} />
                <label className="custom-control-label" htmlFor={"hideAddress-yes"}>Yes</label>
              </div>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"hideAddress-no"} className="custom-control-input" checked={hideAddress === false}  onChange={toggleHideAddress(false)} />
                <label className="custom-control-label" htmlFor={"hideAddress-no"}>No</label>
              </div>
            </td>
          </tr>}
          {!!combinedLocationServicesMap.listingManagement && <tr>
            <td>Permanently Closed</td>
            <td>
              <div className="custom-control custom-checkbox control-spacer-left inline-block">
                <input type="checkbox" id={"permanentlyClosed-yes"} className="custom-control-input" checked={permanentlyClosed === true} onChange={togglePermanentlyClosed(true)} />
                <label className="custom-control-label" htmlFor={"permanentlyClosed-yes"}>Yes</label>
                <div className="custom-control custom-checkbox control-spacer-left inline-block">
                  <input type="checkbox" id={"permanentlyClosed-no"} className="custom-control-input" checked={permanentlyClosed === false} onChange={togglePermanentlyClosed(false)} />
                  <label className="custom-control-label" htmlFor={"permanentlyClosed-no"}>No</label>
                </div>
              </div>
            </td>
          </tr>}
        </tbody>
      </table>
    </div>
  </div>
}

export default BulkLocationEditorGeneralLocationTypeStatus;